import BaseApiClient from '../BaseApiClient';
import { filenameFromContentDisposition } from '../savings-products/response-helpers';
import type {
  SavingsDashboardCustomerExportScope,
  SavingsDashboardDepositMetrics,
  SavingsDashboardMetrics
} from '@/interfaces/SavingsDashboard.interface';

const API_VERSION = { Version: '2026-01-20' };

export class ApiSavingsDashboard extends BaseApiClient {
  async getMetrics(): Promise<SavingsDashboardMetrics> {
    const res = await this.client.get('/savings-dashboard', {
      headers: API_VERSION
    });
    return res.data.data;
  }

  async getDepositMetrics(): Promise<SavingsDashboardDepositMetrics> {
    const res = await this.client.get('/savings-dashboard/deposits', {
      headers: API_VERSION
    });
    return res.data.data;
  }

  async exportCustomers(
    scope: SavingsDashboardCustomerExportScope
  ): Promise<{ blob: Blob; filename: string }> {
    const res = await this.client.get('/savings-dashboard/customers/export', {
      params: { scope },
      responseType: 'blob',
      headers: { ...API_VERSION, Accept: 'text/csv' }
    });
    return {
      blob: new Blob([res.data], { type: 'text/csv;charset=utf-8' }),
      filename: filenameFromContentDisposition(
        res.headers['content-disposition'],
        `savings-customers-${scope.replace('_', '-')}.csv`
      )
    };
  }
}

export * from './query-keys';
export * from './use-savings-dashboard-queries';
export * from './use-savings-dashboard-mutations';
